const VIEW_SESSION_KEY = 'bilt_view_session';

/** First-party anonymous view session (uuid v4). Used for view-count dedup. */
export function getViewSessionToken(): string {
  try {
    const existing = localStorage.getItem(VIEW_SESSION_KEY);
    if (existing && existing.length >= 8) {
      return existing;
    }
    const token =
      typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function'
        ? crypto.randomUUID()
        : `${Date.now()}-${Math.random().toString(36).slice(2, 12)}`;
    localStorage.setItem(VIEW_SESSION_KEY, token);
    return token;
  } catch {
    return `${Date.now()}-${Math.random().toString(36).slice(2, 12)}`;
  }
}
